import React from "react";

/**
 * Build a recharts `dot` render function that draws a small clickable circle and
 * fires `onSelect(payload)` when clicked — the reliable way to catch per-point
 * clicks in recharts (a Line-level `onClick` does not fire from the dots). A
 * null cell (gap, no coordinate) renders nothing so the line still breaks there.
 *
 * Shared by the Score Trends and grouped time-series charts so the two stay in
 * lockstep (#1402). `payload` is the recharts data row for the point.
 */
export function makeClickableDot(opts: {
  color: string;
  radius: number;
  /** Prefix for the per-point React key; keep unique across a chart's lines. */
  keyPrefix: string;
  onSelect: (payload: any) => void;
}) {
  const { color, radius, keyPrefix, onSelect } = opts;
  return function ClickableDot(dotProps: any) {
    const { cx, cy, index, payload } = dotProps;
    const key = `${keyPrefix}-${index}`;
    if (typeof cx !== "number" || typeof cy !== "number") {
      return <g key={key} />;
    }
    return (
      <circle
        key={key}
        cx={cx}
        cy={cy}
        r={radius}
        fill={color}
        style={{ cursor: "pointer" }}
        onClick={() => onSelect(payload)}
      />
    );
  };
}
